module.exports = __webpack_public_path__ + "static/media/icon_weixian.02a01196.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_weixian.svg
// module id = 251
// module chunks = 0